import React, { Component } from 'react'
import { Card, Pagination, Container, Row, Col } from 'react-bootstrap'
import { Navigation } from './Navigation'
import { Footer } from './Footer'

// Importación de imágenes
import img18 from './EquipoMedico/img18.jpg'
import img23 from './EquipoMedico/img23.jpg'
import img24 from './EquipoMedico/img24.jpg'
import img25 from './EquipoMedico/img25.jpg'
import img26 from './EquipoMedico/img26.jpg'
import img27 from './EquipoMedico/img27.jpg'
import img28 from './EquipoMedico/img28.jpg'
import img29 from './EquipoMedico/img29.jpg'
import img30 from './EquipoMedico/img30.jpg'
import img31 from './EquipoMedico/img31.jpg'
import img32 from './EquipoMedico/img32.jpg'
import img33 from './EquipoMedico/img33.jpg'
import img34 from './EquipoMedico/img34.jpg'
import img35 from './EquipoMedico/img35.jpg'
import img36 from './EquipoMedico/img36.jpg'
import img37 from './EquipoMedico/img37.jpg'
import img38 from './EquipoMedico/img38.jpg'
import img39 from './EquipoMedico/img39.jpg'
import img40 from './EquipoMedico/img40.jpg'
import img41 from './EquipoMedico/img41.jpg'

export class Insumo2 extends Component {
    render() {
        // Array de objetos para renderizar las cards de forma más eficiente
        const productos = [
            { id: 18, titulo: "Esparadrapo de Seda", img: img18, desc: "Varias medidas: 1/2\", 1\" y 2\" x 10 ydas." },
            { id: 23, titulo: "Micropore", img: img23, desc: "1.25x10ydas, 2.5x10yds, 5x10yds y 7.5X10yds." },
            { id: 24, titulo: "Mascarilla", img: img24, desc: "Productos descartables" },
            { id: 25, titulo: "Pericraneales", img: img25, desc: "Productos descartables" },
            { id: 26, titulo: "Bolsa Para Orina", img: img26, desc: "Pediatrica" },
            { id: 27, titulo: "Ropa para Cirujano", img: img27, desc: "Descartable, Variedad de colores" },
            { id: 28, titulo: "Ropa para Cirujano", img: img28, desc: "Descartable, Variedad de colores" },
            { id: 29, titulo: "Sonda Estomacal", img: img29, desc: "Productos descartables" },
            { id: 30, titulo: "Sonda Foley", img: img30, desc: "Productos descartables" },
            { id: 31, titulo: "Sonda Levin", img: img31, desc: "Productos descartables" },
            { id: 32, titulo: "Sonda Foley", img: img32, desc: "Productos descartables" },
            { id: 33, titulo: "Sonda Nelaton", img: img33, desc: "Productos descartables" },
            { id: 34, titulo: "Sonda Rectal", img: img34, desc: "Productos descartables" },
            { id: 35, titulo: "Sondas Estomacales", img: img35, desc: "Productos descartables" },
            { id: 36, titulo: "Tubos Endotraqueales", img: img36, desc: "Variedad de Estilos" },
            { id: 37, titulo: "Tubos Endotraqueales", img: img37, desc: "Variedad de Estilos" },
            { id: 38, titulo: "Equipo de Suero", img: img38, desc: "Ventilado en 'Y'" },
            { id: 39, titulo: "Jeringas Descartables", img: img39, desc: "Productos descartables" },
            { id: 40, titulo: "Guantes Descartables", img: img40, desc: "Productos descartables" },
            { id: 41, titulo: "Hisopos de Madera", img: img41, desc: "Bolsa 100 Unidades" }
        ];

        return (
            <div>
                <Navigation />
                <br />
                    <h1 className="text-center">Insumo medico</h1>
                    
                <Container className="mt-4">
                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/insumo">{1}</Pagination.Item>
                        <Pagination.Item active>{2}</Pagination.Item>
                        <Pagination.Item href="/insumo3">{3}</Pagination.Item>
                    </Pagination>

                    {/* Reemplazo de CardDeck por Row con gutter (g-4) */}
                    <Row xs={1} md={2} className="g-4 mb-4">
                        {productos.map((prod) => (
                            <Col key={prod.id}>
                                <Card className="h-100">
                                    <Card.Header><h5>Productos descartables</h5></Card.Header>
                                    <Card.Body>
                                        <Row>
                                            <Col xs={7}>
                                                <Card.Title className="color-texto">{prod.titulo}</Card.Title>
                                                <Card.Text style={{ fontSize: '0.9rem' }}>
                                                    {prod.desc}
                                                </Card.Text>
                                            </Col>
                                            <Col xs={5}>
                                                <Card.Img variant="top" src={prod.img} />
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/insumo">{1}</Pagination.Item>
                        <Pagination.Item active>{2}</Pagination.Item>
                        <Pagination.Item href="/insumo3">{3}</Pagination.Item>
                    </Pagination>
                </Container>
                <Footer />
            </div>
        )
    }
}